// extracted by mini-css-extract-plugin
export default {"initialization-loader":"CrFmXg","initializationLoader":"CrFmXg","custom":"oo97Ea"};